
var clickedElm = document.querySelectorAll('a[data-modal-type="case-preview"]');

var distanceToTop;
var bodyHeight;
var i;
for (let i = 0; i < clickedElm.length; i++) {
  const element = clickedElm[i];
  element.addEventListener('click', function () {
    var distanceToTop = element.parentElement.parentElement.parentElement.offsetTop + 200;
    var bodyHeight = document.body.scrollHeight;

    setTimeout(() => {
      document.querySelector('.modal-casepreview .modal-dialog').style.top = distanceToTop + 'px';
      document.querySelector('.modal-casepreview').style.height = bodyHeight + 'px';
    }, 100);
  })
}





// WEBPACK FOOTER //
// ./scripts/components/getposition.js